import React, { useState, useRef } from 'react';

const TimelineItem = ({ year, title, company, description, location, logo, url }) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!isCardHovered) {
      setMousePos({ x: e.clientX, y: e.clientY });
    }
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      if (!isCardHovered) {
        setIsHovered(false);
      }
    }, 100);
  };

  const handleCardMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsCardHovered(true);
  };

  const handleCardMouseLeave = () => {
    setIsCardHovered(false);
    setIsHovered(false);
  };

  return (
    <div
      className="timeline-item"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="timeline-sidebar">
        <span className="timeline-year">{year}</span>
      </div>
      <div className="timeline-content">
        <div className="timeline-main">
          <span className="timeline-company">{company}</span>
          {title && <span className="timeline-role"> — {title}</span>}
        </div>
        {/* Mobile: show description inline */}
        {description && (
          <p className="timeline-description-mobile">{description}</p>
        )}
      </div>
      {/* Desktop: hover card near cursor */}
      {description && (isHovered || isCardHovered) && (
        <div
          className="timeline-hover-card"
          style={{
            position: 'fixed',
            left: mousePos.x + 16,
            top: mousePos.y + 16,
          }}
          onMouseEnter={handleCardMouseEnter}
          onMouseLeave={handleCardMouseLeave}
        >
          {logo && (
            <img
              src={logo}
              alt={`${company} logo`}
              className="timeline-card-logo"
            />
          )}
          <div className="timeline-card-text">
            <p className="timeline-card-description">{description}</p>
            {url && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="timeline-card-link"
              >
                <span className="timeline-card-arrow">→</span> {new URL(url).hostname.replace('www.', '')}
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimelineItem;
